import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { FulfilmentService } from '../../../core/delivery/fulfilment.service';

/**
 * D4A — gate every delivery route on the store actually having delivery
 * enabled. Resolves fulfilment-config; if delivery is off (or the token is
 * invalid), redirects to the store landing so the feature stays dark and the
 * existing token routes keep working. No flash of delivery UI.
 */
export const deliveryEnabledGuard: CanActivateFn = (route) => {
  const fulfilment = inject(FulfilmentService);
  const router = inject(Router);
  const token = route.paramMap.get('publicToken') ?? '';

  const landing = router.parseUrl(`/t/${token}`);

  return fulfilment.getConfig(token).pipe(
    map(res => (res.ok && res.data.deliveryOrderingEnabled) ? true : landing),
    catchError(() => of(landing)),
  );
};
